<template>
  <div class="lobby">
    <NuxtChild :key="isLoggedIn" />
    <div v-if="!isValidRoutes" class="container">
      <div class="lobby__wrapper">
        <img
          src="/img/lobby/chest.webp"
          alt="chest image"
          class="lobby__image"
        />
        <UiText
          font="hero-display-5"
          color="typography-title01"
          :text="$t('lobby.notFound.title')"
          align-center
          class="lobby__title"
        />
        <UiText
          font="body-text"
          color="typography-body01"
          :text="$t('lobby.notFound.description')"
          align-center
          class="lobby__description"
        />
        <UiBtn
          class="lobby__register"
          color="primary"
          :text="$t('registration')"
          @click="openLoginModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PARAM_PAGE, ENUM_CATEGORY } from '@/components/Lobby/enum.js'

export default {
  name: 'LobbyPage',
  beforeRouteUpdate(to, from, next) {
    const isCurrentPage = to.path === from.path
    const isLobyPages = to.name.includes(PARAM_PAGE) && from.name.includes(PARAM_PAGE)

    if (isLobyPages && !isCurrentPage) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    next()
  },
  layout: 'main',
  data() {
    return {
      ENUM_CATEGORY,
      isValidRoutes: false,
      isCheckingRoute: true,
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    isShowPage() {
      return this.isLoggedIn || !this.isCheckingRoute
    },
  },
  watch: {
    $route: {
      handler() {
        this.checkRouteExists()
      },
    },
  },
  mounted() {
    this.checkRouteExists()
  },
  methods: {
    checkRouteExists() {
      const staticCategory = [
        ENUM_CATEGORY.FAVOURITES.TERM,
        ENUM_CATEGORY.LAST.TERM,
      ]

      const isReservedHiddenRoute = staticCategory.includes(this.$route.params[PARAM_PAGE])
      if (!(isReservedHiddenRoute && !this.isLoggedIn)) {
        this.isValidRoutes = true
      }
      this.isCheckingRoute = false
    },
    openLoginModal() {
      this.$newModal.openAuthOrRegister()
    },
  },
}
</script>

<style scoped lang="scss">
.lobby {
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 386px;
    margin: var(--spaces-l) auto var(--spaces-2xl);
    @include media(desktop) {
      margin-top: var(--spaces-xl);
    }
  }
  &__image {
    height: 140px;
    @include media(desktop) {
      height: 188px;
    }
  }
  &__title,
  &__register {
    margin-top: var(--spaces-xl);
  }
  &__description {
    margin-top: var(--spaces-s);
  }
  &__register {
    width: 100%;
  }
}
</style>
